import app_2 from '@/public/features/consumer_financing/Frame-1171279152.webp';
import bg from '@/public/features/consumer_financing/Main.webp';

const intro = {
  tag: '',
  description: `Enable financing options for your clients effortlessly, helping them manage costs and make larger purchases. Our flexible financing solutions ensure that you can offer the best terms for both your business and your customers.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Boost your sales and customer satisfaction',
  second_title: ' with our Consumer Financing options',
};

const blog = {
  title: 'Our Blog',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
for the latest trends and tips in service scheduling software free`,
};

const bookDemo = {
  title: `Book a Free Demo`,
  description: `Book a free demo to unlock the full potential of our software for HVAC contractors! Orcatec team is here to guide you. Fill out the form below to receive expert consultation. Don’t miss this opportunity to transform your HVAC business with Orcatec's cutting-edge solutions, specially designed for HVAC contractors!`,
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What is Consumer Financing?`,
  },
  title: `What is Consumer Financing?`,
  description: `Consumer financing allows your customers to pay for your services over time, making it easier for them to choose your business. This feature helps you increase sales and client satisfaction by offering manageable payment plans.`,
  item: [
    {
      title: 'Enable with ease',
      description:
        'Our system allows you to set up consumer financing quickly and effortlessly. With just a few clicks, you can start offering financing options to your clients.',
    },
    {
      title: 'Set percentage rates and terms',
      description: `Customize the financing options by setting your preferred interest rates and repayment terms. This flexibility ensures you can offer plans that best suit your business and your client's financial situations.`,
    },

    {
      title: 'Offer clients by default',
      description: `Automatically present financing options to your clients as part of the checkout process. Make it simple for them to choose a payment plan, increasing the likelihood of completed sales and higher customer satisfaction.`,
    },
  ],
};

export { blog, bookDemo, fullArticle2, intro };
